export enum EKwikUILabelValuePairOrientation {
  VERTICAL = "vertical",
  HORIZONTAL = "horizontal"
}
export type TKwikUILabelValuePairOrientation = "vertical" | "horizontal";

export enum EKwikUILabelValuePairType {
  BOOLEAN = "boolean",
  IMAGE = "image",
  PDF = "pdf",
  VIDEO = "video",
  DOC = "doc",
  OBJECT = "object",
  ARRAY = "array"
}
export type TKwikUILabelValuePairType =
  | "boolean"
  | "image"
  | "pdf"
  | "video"
  | "doc"
  | "object"
  | "array";
